import { Link } from 'react-router-dom';

// Services
import { type BlocReassuranceType } from '@/services/blocksSchema';

// Components
import Heading from '@/components/atoms/Heading/Heading';

// Style
import styles from './BlocReassurance.module.css';

interface BlocReassuranceProps {
  title: BlocReassuranceType['title'];
  subTitle: BlocReassuranceType['subTitle'];
  items: BlocReassuranceType['items'];
  button: BlocReassuranceType['button'];
  reinsuranceLine: BlocReassuranceType['reinsuranceLine'];
}

function BlocReassurance({
  title,
  subTitle,
  items,
  button,
  reinsuranceLine,
}: BlocReassuranceProps) {
  
  return (
    <div className={styles.container}>
      <div className={styles.content}> 
        <div className={styles.card}>
          <Heading
            title={title}
            size='h4'
            Tag='h4'
            color='dark'
            align='center'
          />
          <p className={styles['sub-title']}>
            {subTitle}
          </p>
          <div className={styles.items}>
            {
              items.map((item) => (
                <div key={item.title} className={styles.item}>
                  <img
                    src={item.icon.url}
                    alt={item.icon.alternativeText || ''}
                    className={styles['item-icon']}
                  />
                  <p className={styles['item-title']}>
                    {item.title}
                  </p>
                  <p className={styles['item-sub-title']}>
                    {item.subTitle}
                  </p>
                </div>
              ))
            }
          </div>
          <Link to={button.url} className={styles.button}>
            {button.title}
          </Link>
          <div className={styles['reinsurance-list']}>
            {
              reinsuranceLine.map(({ text }) => (
                <div key={text} className={styles['reinsurance-item']}>
                  {text}
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlocReassurance;
